var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-banner",
    {
      attrs: {
        icon: "mdi-alert",
        color: "light-blue darken-1",
        "single-line": "",
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    href: _vm.repository + _vm.changelog,
                    target: "_blank",
                    color: "black",
                  },
                },
                [_vm._v("Learn More")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "red darken-4" },
                  on: {
                    click: function ($event) {
                      _vm.updateAvailable = false
                    },
                  },
                },
                [_vm._v("Dismiss")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.updateAvailable,
        callback: function ($$v) {
          _vm.updateAvailable = $$v
        },
        expression: "updateAvailable",
      },
    },
    [
      _vm._v(
        " There is a newer version of Heimdall available. The latest version is "
      ),
      _c("strong", [_vm._v("v" + _vm._s(_vm.latestVersion))]),
      _vm._v(" and you are running "),
      _c("strong", [_vm._v("v" + _vm._s(_vm.version))]),
      _vm._v(". "),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }